<div class="lmo-module">
  <router-outlet></router-outlet>
</div>
